import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';

import { Box, Button, Typography } from '@material-ui/core';

import CenteredWrapper from 'components/wrappers/CenteredWrapper';

import { checkNumbers, required, numbers, composeValidators } from 'validators/validationInputFields';

import TextField from 'inputs/forms/TextField';

const MfaChallenge = props => {
    const handleKeyPress = useCallback(event => {
        if (!checkNumbers(event.key)) {
            event.preventDefault();
        }
    }, []);

    return (
        <CenteredWrapper>
            <Box my={2} textAlign="center">
                <Typography variant="h1">
                    {l('Two-step verification')}
                </Typography>
            </Box>
            <Box px={12} mb={2}>
                <Typography>
                    {l('Enter the code from your authenticator app')}
                </Typography>
            </Box>
            <Box mt={4}>
                <Form onSubmit={props.onClickVerify}>
                    {({ submitError, submitting, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box px={12} mb={4}>
                                <Field
                                    fullWidth
                                    name="code"
                                    innerError={submitError || null}
                                    validate={composeValidators(required, numbers)}
                                    placeholder={l('Enter your code')}
                                    component={TextField}
                                    onKeyPress={handleKeyPress}
                                />
                            </Box>
                            <Box px={12} mt={4}>
                                <Button
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={submitting}
                                >
                                    {l('Confirm')}
                                </Button>
                            </Box>
                            <Box px={12} mt={2}>
                                <Button
                                    fullWidth
                                    color="primary"
                                    disabled={submitting}
                                    onClick={props.onClickCancel}
                                >
                                    {l('Cancel')}
                                </Button>
                            </Box>
                        </form>
                    )}
                </Form>
            </Box>
        </CenteredWrapper>
    );
};

MfaChallenge.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickVerify: PropTypes.func.isRequired,
};

export default MfaChallenge;
